module.exports = __webpack_public_path__ + "images/dropdown-arrow-210688dfa092acdec7011173d9491e97.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/dropdown-arrow.png
// module id = 38
// module chunks = 0